export const SIDEBAR_EXPAND_UPDATE = "SIDEBAR_EXPAND_UPDATE";
export const SIDEBAR_EXPAND_RESET = "SIDEBAR_EXPAND_RESET";
